import { WaitlistForm } from './WaitlistForm';
import { WaitlistCounter } from './WaitlistCounter';
import { useT } from '@/lib/i18n';

export const WaitlistCTA = () => {
  const t = useT();
  return (
    <section
      id="waitlist"
      data-testid="section-waitlist-cta"
      className="relative py-20 md:py-28"
    >
      <div className="om-container">
        <div className="relative overflow-hidden rounded-[32px] border border-[var(--om-border)] bg-white shadow-[0_30px_80px_-40px_rgba(10,14,26,0.25)]">
          <div aria-hidden className="pointer-events-none absolute inset-0">
            <div
              className="absolute -left-24 -top-24 h-[420px] w-[420px] rounded-full blur-3xl"
              style={{ background: 'radial-gradient(closest-side, rgba(139,92,246,0.28), transparent 70%)' }}
            />
            <div
              className="absolute -right-24 -bottom-24 h-[480px] w-[480px] rounded-full blur-3xl"
              style={{ background: 'radial-gradient(closest-side, rgba(16,185,129,0.22), transparent 70%)' }}
            />
            <div
              className="absolute right-[10%] top-[10%] h-[220px] w-[220px] rounded-full blur-3xl"
              style={{ background: 'radial-gradient(closest-side, rgba(249,115,22,0.22), transparent 70%)' }}
            />
          </div>

          <div className="relative grid grid-cols-1 gap-10 p-10 md:p-16 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <span className="om-eyebrow">{t('home.waitlist_cta.eyebrow')}</span>
              <h2
                className="om-h1 mt-5 text-[36px] sm:text-[44px] lg:text-[56px] text-[var(--om-ink)]"
                data-testid="waitlist-cta-title"
              >
                {t('home.waitlist_cta.title_l1')}<br />
                <span
                  style={{
                    backgroundImage:
                      'linear-gradient(120deg, #10B981 0%, #8B5CF6 45%, #F43F5E 80%, #F97316 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  {t('home.waitlist_cta.title_l2')}
                </span>
              </h2>
              <p className="mt-5 max-w-xl text-base md:text-lg leading-relaxed text-[var(--om-muted)]">
                {t('home.waitlist_cta.subtitle')}
              </p>
            </div>

            <div className="lg:col-span-5">
              <div className="flex h-full flex-col justify-center">
                <WaitlistForm source="cta_final" variant="cta" />
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-[var(--om-muted-2)]">
                  <span className="inline-flex items-center gap-3">
                    <span className="inline-flex h-6 w-6 items-center justify-center rounded-full border border-[var(--om-border)] bg-white">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6L9 17l-5-5" stroke="#10B981" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                    {t('waitlist.no_spam')}
                  </span>
                  <WaitlistCounter />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
